export const LOGGED_IN = 'LOGGED_IN' as const;
export const LOGGED_OUT = 'LOGGED_OUT' as const;
export const SOFT_LOGGED_IN = 'SOFT_LOGGED_IN' as const;

export type LoginState =
  | typeof LOGGED_IN
  | typeof LOGGED_OUT
  | typeof SOFT_LOGGED_IN;
